import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../components/fields/file-input-field/FileInputField.vue";
import {
  TIPO_ALTERACAO,
  TIPO_ALTERACAO_INTERRUPCAO,
  TIPO_ALTERACAO_PRORROGACAO,
  tipoAlteracaoEnum,
  TiposFeriasEnum,
  tipoPerfil
} from "../../../constants";
import {
  SnackBarModule
} from "../../../modules/SnackBarModule";
import {
  AlterarPeriodoService
} from "../../../services/AlterarPeriodoService";
import {
  SolicitarFeriasService
} from "../../../services/SolicitarFeriasService";

import moment from "moment";

import {calcularDiasCorridos, checarSeDataEstaEntreAsDatas} from "../../../helper/helper.js";

export default {
  name: "AlterarPeriodo",

  props: {
    selected: {
      required: true,
    },
    status: {
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField,
  },

  data: () => ({
    form: {},
    dataInicio: "",
    options: {
      tipoAlteracao: [],
      prorrogacao: [],
      interrupcao: [],
    },
    loading: false,
    rulesAdiamentoAntecipaoMsg: "Em caso de antecipção periodo não pode ser posterior as férias solicitadas",
    limiteDias: 25,
    titulo: 'Alterar Período',
    numeroDiasTitulo: 'Número de dias úteis solicitados',
    disabledNumDiaProInt: false
  }),

  computed: {
    showAnexo() {

      if (this.form.tipoAlteracao == null) {
        return false;
      }
      // Verifica se as opções incluem 1 ou 2
      const hasProrrogacaoInterrupcao = this.options.tipoAlteracao.some(
        option => option.value === 1 || option.value === 2
      );
  
      // Verifica o valor selecionado pelo usuário
      const isSelectedProrrogacaoInterrupcao = this.form.tipoAlteracao === 1 || this.form.tipoAlteracao === 2;
      const isSelectedAdiamentoAntecipacao = this.form.tipoAlteracao === 3 || this.form.tipoAlteracao === 4;
  
      // Condições:
      // 1. Se as opções incluem 1 ou 2 e nada foi selecionado ainda, mostrar o anexo
      if (hasProrrogacaoInterrupcao && !this.form.tipoAlteracao) {
        return true;
      }
      // 2. Se as opções incluem 1 ou 2 e o valor selecionado é 1 ou 2, mostrar o anexo
      if (hasProrrogacaoInterrupcao && isSelectedProrrogacaoInterrupcao) {
        return true;
      }
      // 3. Se as opções incluem 3 ou 4, nunca mostrar o anexo
      if (isSelectedAdiamentoAntecipacao) {
        return false;
      }
      // 4. Se as opções incluem 1 ou 2 e o valor selecionado for 3 ou 4, não mostrar o anexo
      if (hasProrrogacaoInterrupcao && isSelectedAdiamentoAntecipacao) {
        return false;
      }
  
      // Se nenhuma condição for atendida, não mostrar o anexo
      return false;
    },
    enumTipoAlteracao() {
      return tipoAlteracaoEnum;
    },
    exibirProrrogarOuInterromper() {

      if (this.form.tipoAlteracao == 3 || this.form.tipoAlteracao == 4 || this.form.tipoAlteracao == null) {
        return false;
      } 

      return true;
      // const now = moment(new Date());
      // return checarSeDataEstaEntreAsDatas(this.form.dataInicio, this.form.dataFim, now);
    },
    disabledDias () {
      return this.form.tipoAlteracao == this.enumTipoAlteracao.PRORROGACAO || this.form.tipoAlteracao == this.enumTipoAlteracao.INTERRUPCAO || this.enumTipoAlteracao.ANTECIPACAO;
    }
  },

  beforeMount(){
    this.inicializarModal();

  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.inicializarModal();
  

      }

    },
    'form.dataInicioAltInt': {
      handler(value) {
        if (value && this.form.numeroDiasAltInt) {
          this.calculateDaysAltInt()
        }
      },
    },
    'form.prorrogacao': {
      handler(value) {
        switch (value) {
          case "Luto":
          case "Núpcias":
            this.form.numeroDiasAltInt = 8;
            this.disabledNumDiaProInt = true;
            break;
          case "Paternidade": 
          case "Adoção Paterna":
            this.form.numeroDiasAltInt = 20;
            this.disabledNumDiaProInt = true;
            break; 
          default:
            this.form.numeroDiasAltInt = null;
            this.disabledNumDiaProInt = false;
        }
      },
      deep: true
    },
    'form.interrupcao': {
      handler(value) {
        if (value === "Maternidade" || value === "Adoção Materna") {
          this.form.numeroDiasAltInt = 180;
          this.disabledNumDiaProInt = true;
        } else {
          this.form.numeroDiasAltInt = null;
          this.disabledNumDiaProInt = false;
        }
      },
      deep: true
    }
  },

  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.limiteDias = 90
        this.titulo = 'Alterar Período Prêmio'
        this.numeroDiasTitulo = 'Número de dias corridos solicitados';

      }else{
        this.limiteDias = 25
        this.titulo = 'Alterar Período'
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
      }
      this.initializeForm();
      this.options.tipoAlteracao = TIPO_ALTERACAO;
      this.options.prorrogacao = TIPO_ALTERACAO_PRORROGACAO;
      this.options.interrupcao = TIPO_ALTERACAO_INTERRUPCAO;
      this.initializeOptions()
      this.dataInicio = this.form.dataInicio;
    },
    verificarSePerfilTemPermissao(perfil){
      return this.$store.state.perfil_id == tipoPerfil[perfil];
    },
    prepareForm() {
      if (this.validateForm()) {
        const formData = new FormData();
        formData.append("justificativa", this.form.justificativa);
        formData.append("arquivo", this.form.anexo);
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("id_tipo_alteracao_alterar_periodo", this.form.tipoAlteracao);

        if (this.form.dataFimAltInt== null) {
          formData.append("data_inicio", moment(this.form.dataInicio).format("YYYY-MM-DD"));
          formData.append("data_fim", moment(this.form.dataFim).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDiasAltInt);

        } else {
          formData.append("data_inicio", moment(this.form.dataInicioAltInt).format("YYYY-MM-DD"));
          formData.append("data_fim", moment(this.form.dataFimAltInt).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDiasAltInt);
        }

        if (this.form.tipoAlteracao !== this.enumTipoAlteracao.PRORROGACAO) {

          this.form.prorrogacao = null;
        }
        if (this.form.tipoAlteracao !== this.enumTipoAlteracao.INTERRUPCAO) {

          this.form.interrupcao = null;
        }
        
        if (this.form.prorrogacao) {
          formData.append(`entidade_tipo_alteracao_json[0]`, this.form.prorrogacao);
        }
        if (this.form.interrupcao) {
          formData.append(`entidade_tipo_alteracao_json[0]`, this.form.interrupcao);

        }
        if (this.form.tipoAlteracao === this.enumTipoAlteracao.PRORROGACAO) {
          formData.append("data_inicio", moment(this.form.dataInicioAltInt).format("YYYY-MM-DD")); 
          formData.append("data_fim", moment(this.form.dataFimAltInt).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDiasAltInt);
      }

        // if (this.form.tipoAlteracao === this.enumTipoAlteracao.PRORROGACAO && this.form.dataFimAltInt > this.selected.dataFin) {
        //   SnackBarModule("A prorrogação não pode ser feita fora do período de férias.", "error");
        //   return;
        // }
        this.sendForm(formData);
        return;
      }

    },

    validateForm() {

      if (this.form.tipoAlteracao === this.enumTipoAlteracao.PRORROGACAO || this.form.tipoAlteracao === this.enumTipoAlteracao.INTERRUPCAO) {
        if (this.form.justificativa == null || this.form.justificativa == "") {
          SnackBarModule("Campo justificativa é obrigatório e não foi informado", "error");
          return false;
        }
      }

      /*if (this.form.tipoAlteracao === this.enumTipoAlteracao.PRORROGACAO) {
        if (this.form.dataFimAltInt > this.selected.dataFin) {
          SnackBarModule("A prorrogação não pode ultrapassar o período original de férias.", "error");
          return false;
        }
      }*/

      if(!this.rulesAdiamentoAntecipao()){
        SnackBarModule(this.rulesAdiamentoAntecipaoMsg, "error")
        return false;

      }

      if (this.form.tipoAlteracao == this.enumTipoAlteracao.INTERRUPCAO || this.form.tipoAlteracao == this.enumTipoAlteracao.PRORROGACAO) {

        if (!(this.form.dataFimAltInt== null != null && this.form.tipoAlteracao != null)) {
          if( this.form.dataInicioAltInt >= this.form.dataInicio && this.form.dataFimAltInt >= this.form.dataFim){
            SnackBarModule("A data informada está fora do período de férias solicitada.", "error");
            return false
          }
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
          return false
        }

        if (this.form.dataInicioAltInt < this.form.dataInicio) {
          SnackBarModule("A data de início está fora do intervalo permitido.", "error");
          return false;
        }
        
        return true
      }
      //
      if (this.form.tipoAlteracao == this.enumTipoAlteracao.ADIAMENTO || this.form.tipoAlteracao == this.enumTipoAlteracao.ANTECIPACAO) {
        if (!(this.form.dataInicio != "" && this.form.dataFim != "" && this.form.numeroDias != "" && this.form.tipoAlteracao != null && this.form.justificativa != null)) {
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
          return false
        }
        return true;
      }
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
      return false
    },

    async sendForm(formData) {
      this.loading = true;
      
      const response = this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO'] 
        ? await AlterarPeriodoService.salvarAlteracao(formData)
        : await AlterarPeriodoService.salvarAlteracaoV2(formData);

      if (response) {
        this.close();
      }
      this.loading = false;
    },

    async calculateDays() {
      if (this.form.dataInicio != null) {
        if (this.selected.idTipo != TiposFeriasEnum['FERIAS_PREMIO']) {
          const formData = new FormData();
          formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDias);
          formData.append("tipo_alteracao", this.form.tipoAlteracao);

          if (this.form.tipoAlteracao == 1 || this.form.tipoAlteracao == 2) {
            this.form.dataFim = calcularDiasCorridos(this.form.dataInicio, this.form.numeroDias)
          } else {
            const response = await SolicitarFeriasService.calcularDiasUteis(formData);
            this.form.dataFim = response.dataFim;
            this.form.numeroDias = response.dias_uteis;
          }
          return;
        }

        this.form.dataFim = calcularDiasCorridos(this.form.dataInicio, this.form.numeroDias)
        return;
      }
      return SnackBarModule("Prencha o campo de data inicio teste", "error");
    },

    async calculateDaysAltInt() {
      if (this.form.dataInicioAltInt != null) {
        this.form.dataFimAltInt = calcularDiasCorridos(this.form.dataInicioAltInt, this.form.numeroDiasAltInt)
        return;
      }
      return SnackBarModule("Prencha o campo de data inicio", "error");
    },

    close() {
      this.clean();
      this.$emit("on-close");
    },

    clean() {
      this.initializeForm();
      this.form.prorrogacao = null;
      this.form.interrupcao = null;
    },

    initializeOptions() {
      const now = moment(new Date());
      const emGozo = checarSeDataEstaEntreAsDatas(this.form.dataInicio, this.form.dataFim, now);
      const isChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
      const naoIniciada = moment(this.form.dataInicio).isAfter(now, 'day');
    
      let options = [];
    
      if (this.status === "Aprovado" && emGozo) {
    
        options = [{ value: 1, text: "Prorrogação", }, { value: 2, text: "Interrupção" }];
    
      } else if (this.status === "Aprovado" && naoIniciada) {
    
        options = [{ value: 3, text: "Adiamento", }, { value: 4, text: "Antecipação" }];
    
      } else if (this.status !== "Aprovado" && emGozo) {
        options = [{ value: 1, text: "Prorrogação", }, { value: 2, text: "Interrupção" }];
      } else {
        options = [{ value: 3, text: "Adiamento", }, { value: 4, text: "Antecipação" }];
      }
    
      if (this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']) {
        options = TIPO_ALTERACAO.slice(2, 4);
      }

      if (isChefeSeplan) {
        options = [
          { value: 1, text: "Prorrogação" },
          { value: 2, text: "Interrupção" },
          { value: 3, text: "Adiamento" },
          { value: 4, text: "Antecipação" }
        ];
      }
    
      this.options.tipoAlteracao = options;
    },

    rulesAdiamentoAntecipao(){

      const dataInicio = Date.parse(this.dataInicio);
      const dataInicioModificada = Date.parse(this.form.dataInicio);
      let verifed = true

      if (this.form.tipoAlteracao == this.enumTipoAlteracao.ADIAMENTO) {
          this.rulesAdiamentoAntecipaoMsg = "Em caso de adiamento periodo não pode ser anterior ou igual as férias solicitadas";
          verifed = dataInicioModificada > dataInicio
      }

      if (this.form.tipoAlteracao == this.enumTipoAlteracao.ANTECIPACAO) {
          this.rulesAdiamentoAntecipaoMsg = "Em caso de antecipção periodo não pode ser posterior ou igual as férias solicitadas";
          verifed =  dataInicioModificada < dataInicio;
      }

      return verifed;
    },

    initializeForm() {
      this.form = {
        dataInicio: this.selected.dataIni,
        dataFim: this.selected.dataFin,
        numeroDias: this.selected.numeroDias,
        numeroDiasAltInt: null,

        dataInicioAltInt: null,
        dataFimAltInt:    null,
        
        tipoAlteracao: null,
        prorrogacao: null,
        interrupcao: null,
        anexo: null,
        justificativa: null
      }
    }
  },
};